import * as React from 'react';
import { Button, Dropdown, Popup } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { ActionWidget, DelayWidget, RandomizerWidget } from 'components/form/trident-campaigns';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import './FlowDesign.scss';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import { renderDropdownItem, getNodeTypeChildOptions } from './util';

export default class CountConditionWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const { model, canActivate, currentNodeKey, parentKeyList } = this.props;
    const buttonStylee = {
      width: 150,
      height: 60,
      borderRadius: 0,
      border: '1px solid #9fe651',
      backgroundColor: '#f2ffe4',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const buttonStyleeClicked = {
      width: 150,
      height: 60,
      borderRadius: 0,
      border: '1px solid #7ed321',
      backgroundColor: '#d2f5ae',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const addButtonSize = {
      fontSize: '1.5em',
      color: '#3498DB',
    };
    // code to decide whether 'add node button'(+ button) needs to be render or not.
    const renderAddButton = _.get(model.nodes[currentNodeKey], 'children', []).length === 0;

    // preparing ancestor list of current clicked node to send it into node preview display.
    const ancestorList = _.concat(parentKeyList, currentNodeKey);
    const parentKey = parentKeyList[parentKeyList.length - 1];
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.countCondition, _.get(model, 'nodesOccMap'));
    const childOptions = getNodeTypeChildOptions(model.targetUserType, nodeTypes.countCondition);

    return (
      <div className={_.get(this.props.model.nodes[parentKey], 'children', []).length > 1 ? 'entry' : 'entry sole'}>
        <span className="wrapDesign">
          <Popup
            trigger={
              <Button style={this.props.clickedNode === this.props.currentNodeKey ? buttonStyleeClicked : buttonStylee} onClick={() => this.props.handleNodePreview(ancestorList, currentNodeKey)}>
                {_.get(model.nodes[currentNodeKey], 'name', defaultName) || defaultName}
              </Button>
            }
            content={getNodePopupContent(model, 'name', currentNodeKey, defaultName)}
          />
          {renderAddButton &&
            <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
              <Dropdown.Menu>
                {childOptions.map(option =>
                  renderDropdownItem(`Add ${option}`, () => this.props.handleAddNode(option, currentNodeKey, ancestorList))
                )}
              </Dropdown.Menu>
            </Dropdown>
          }
        </span>
        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 &&
          <div className="branch lv1">
            {_.get(model.nodes[currentNodeKey], 'children', []).map((childKey, index) => {
              if (model.nodes[childKey].type === 'delay') {
                return (
                  <DelayWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    onModelChange={this.props.onModelChange}
                    model={model}
                    currentNodeKey={childKey}
                    canActivate={canActivate}
                    parentKeyList={ancestorList}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              if (model.nodes[childKey].type === 'randomizer') {
                return (
                  <RandomizerWidget
                    key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                    model={model}
                    canActivate={canActivate}
                    currentNodeKey={childKey}
                    parentKeyList={ancestorList}
                    onModelChange={this.props.onModelChange}
                    handleAddNode={this.props.handleAddNode}
                    handleNodePreview={this.props.handleNodePreview}
                    clickedNode={this.props.clickedNode}
                  />
                );
              }
              return (
                <ActionWidget
                  key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                  onModelChange={this.props.onModelChange}
                  model={model}
                  currentNodeKey={childKey}
                  canActivate={canActivate}
                  handleNodePreview={this.props.handleNodePreview}
                  parentKeyList={ancestorList}
                  clickedNode={this.props.clickedNode}
                />
              );
            })}
          </div>
        }
      </div>
    );
  }
}
